<template>
<div>
    <v-tabs v-model="tab"  background-color="#fafafa" color="basil" grow>
      <v-tab v-for="profile in attributsList" :key="profile.dataSourceId">
        {{ profile.dataSourceDescription }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in attributsList" :key="item.dataSourceId">
        <v-card flat>
            <v-checkbox
                class="select_all_cb"
                v-model="item.selectAll"
                label="Selecionar Todos"
                hide-details
                @change="handleSelectAll"
            ></v-checkbox>
            <v-card-text>
              <v-row class="mt-1">
                    <v-col cols="12" sm="7" :style="$vuetify.breakpoint.xsOnly ? '' : 'max-width: 53%'">
                        <div>
                            <draggable class="list-group" :list="item.attributs" group="people" @change="log">
                                <div
                                    class="list-group-item d-flex flex-row p-0 align-center justify-space-between"
                                    v-for="(element, index) in item.attributs"
                                    :key="element.description"
                                >
                                    <v-checkbox
                                        v-model="element.isSelected"
                                        :label="element.description"
                                        hide-details
                                    ></v-checkbox>
                                    <v-badge
                                        class="mr-4"
                                        bordered
                                        inline
                                    >
                                    <template v-slot:badge>
                                        {{index + 1}}
                                    </template>
                                    </v-badge>
                                </div>
                            </draggable>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
</div>
</template>

<script>
import draggable from "vuedraggable";
export default {
    props: {
        attributsListProps: Array | Object
    },
  components: {
    draggable,
  },
  data() {
    return {
        attributsList: [],
        selectAll: false,
        tab: null
    };
  },
  watch: {
    attributsList: {
        handler: function(newValue, oldValue) {
            this.$emit('on-change-list', newValue);
        },
        deep: true,
        immediate: true
    }
  },
  methods: {
    log: function(evt) {
    //   window.console.log(evt);
    },
    handleSelectAll(value) {
        this.attributsList.forEach(list => {
            list.attributs.forEach(item => {
                Object.assign(item, { isSelected: value });
            })
        })
    }
  },
  mounted() {
    this.attributsList = this.attributsListProps;
  }
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
.list-group-item {
    height: 40px;
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
        margin-left: 5px;

        ::v-deep .v-label {
            margin-top: 5px;
        }
    }
}
::v-deep .v-label {
    margin-top: 5px;
}

.select_all_cb {
    margin-left: 22px;
}
</style>
